'use es6';

import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useState, useRef, useEffect } from 'react';
import LanguageSwitcherPopup from './LanguageSwitcherPopup';
import LanguageUtil from '../util/LanguageUtil';
export default (function () {
  var userLanguage = LanguageUtil.getPrintUserLanguage();

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      popupOpen = _useState2[0],
      setPopupOpen = _useState2[1];

  var popup = useRef(null);

  var onClick = function onClick() {
    setPopupOpen(true);
  };

  var onClickedOutside = function onClickedOutside() {
    setPopupOpen(false);
  }; // handles onBlur properly so we don't intercept the anchor tag clicks


  useEffect(function () {
    var handleClickOutside = function handleClickOutside(event) {
      if (popup.current && !popup.current.contains(event.target)) {
        onClickedOutside();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return function () {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [popup]);
  return /*#__PURE__*/_jsx("div", {
    className: "language-switcher-container",
    children: /*#__PURE__*/_jsxs("div", {
      ref: popup,
      className: "language-switcher",
      tabIndex: "0",
      onClick: onClick,
      children: [userLanguage, /*#__PURE__*/_jsx("span", {
        className: "icon icon-angle-down"
      }), /*#__PURE__*/_jsx(LanguageSwitcherPopup, {
        isOpen: popupOpen
      })]
    })
  });
});